<template>
  <div class="election-map-table" v-if="ready">
    <div class="election-map-table__title">Split Electoral Votes</div>
    <div class="election-map-table__header">
      <div class="election-map-table__header-state">
        <div>State</div>
      </div>
      <div class="election-map-table__header-district">
        <div class="election-map-table__header-district-header">District</div>
        <div class="election-map-table__header-district-num">
          <div>1</div>
          <div>2</div>
          <div>3</div>
        </div>
      </div>
    </div>
    <div class="election-map-table__row">
      <div class="election-map-table__row-legend">NE</div>
      <div class="election-map-table__row-state" :style="neStyleModifiers">2</div>
      <div class="election-map-table__row-district">
        <div class="election-map-table__row-district-entry" :style="ne1StyleModifiers">1</div>
        <div class="election-map-table__row-district-entry" :style="ne2StyleModifiers">1</div>
        <div class="election-map-table__row-district-entry" :style="ne3StyleModifiers">1</div>
      </div>
    </div>
    <div class="election-map-table__row">
      <div class="election-map-table__row-legend">ME</div>
      <div class="election-map-table__row-state" :style="meStyleModifiers">2</div>
      <div class="election-map-table__row-district">
        <div class="election-map-table__row-district-entry" :style="me1StyleModifiers">1</div>
        <div class="election-map-table__row-district-entry" :style="me2StyleModifiers">1</div>
        <div v-if="false" class="election-map-table__row-district-entry" :style="me3StyleModifiers">
          x
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./election-map-table.js"></script>
<style src="./election-map-table.scss" lang="scss"></style>
